const LANGUAGE_CODE_EN = 'en';
const LANGUAGE_CODE_RU = 'ru';
const LANGUAGE_CODE_LIST = [LANGUAGE_CODE_EN, LANGUAGE_CODE_RU];
const LANGUAGE_CODE_DEFAULT = LANGUAGE_CODE_EN;

export {
  LANGUAGE_CODE_EN,
  LANGUAGE_CODE_RU,
  LANGUAGE_CODE_LIST,
  LANGUAGE_CODE_DEFAULT,
};
